import { useState, useCallback } from 'react';
import axios from 'axios';
import { Loader2, Image as ImageIcon } from 'lucide-react';

const API = `/api`;

export const LazyInvoiceImage = ({ invoiceId, invoiceName, onClick, getAuthHeaders }) => {
    const [imageData, setImageData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [loaded, setLoaded] = useState(false);

    const loadImage = useCallback(async () => {
        if (loaded || loading) return;
        setLoading(true);
        try {
            const response = await axios.get(`${API}/invoices/${invoiceId}/image`, {
                headers: getAuthHeaders()
            });
            setImageData(response.data.image_data);
            setLoaded(true);
        } catch (error) {
            console.error('Error loading image:', error);
        } finally {
            setLoading(false);
        }
    }, [invoiceId, loaded, loading, getAuthHeaders]);

    return (
        <div 
            className="w-16 h-16 rounded-lg bg-slate-100 flex items-center justify-center cursor-pointer hover:bg-slate-200 transition-colors overflow-hidden"
            onClick={() => {
                if (imageData) {
                    onClick({ image_data: imageData, name: invoiceName });
                } else {
                    loadImage();
                }
            }}
        >
            {loading ? (
                <Loader2 className="w-5 h-5 animate-spin text-slate-400" />
            ) : imageData ? (
                <img
                    src={`data:image/jpeg;base64,${imageData}`}
                    alt={invoiceName}
                    className="w-full h-full object-cover"
                />
            ) : (
                <div className="flex flex-col items-center">
                    <ImageIcon className="w-5 h-5 text-slate-400" />
                    <span className="text-[10px] text-slate-400 mt-0.5">Ver</span>
                </div>
            )}
        </div>
    );
};
